var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Storage } from "../../../../lib/localstorege.service";
import { Api } from "./game.operations.api";
import { currencyFormat, dateTimeFormat, initialLeftMenu, sportsMenu, useForceUpdate } from "../../../../lib/misc.functions";
import { modalServiceSubject } from "../../../../components/modal/modal";
import { Link, useLocation } from "react-router-dom";
import SportsDetail from "../../widgets/modal/sportsDetail";
import { env } from "../../../../definitions/global.vars";
import { Subject } from "rxjs";
import { ApiService } from "../../../../lib/http.service";
import { betSlipActionSubject, BetSlipOption } from "../../../../store/betslip.store";
import { useTranslation } from "react-i18next";
import { isMobileView } from "../../../../app";
import CashoutDetail from "../../../userCoupon/cashout.detail";
import { member } from "../../../../store/login.store";
import KioskPayout from "../../../userCoupon/kiosk.payout";
import { KioskCheckCoupon } from "../../../userCoupon/kiosk.check.coupon";
var page = 0;
var hasMore = true;
var paramStates = {
    "devam-edenler": 1,
    "kazanan": 2,
    "kaybeden": 3,
    "kayitli": 5,
    "kiosk-won": 12,
};
export var couponDetailSubject = new Subject();
var Sports = function (props) {
    var params = props.params;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var base = '/' + i18n.resolvedLanguage;
    var iddiaStatus = paramStates[params.couponId];
    var isKioskUser = member.is_kiosk;
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    var getHeader = function () {
        if (iddiaStatus < 2) {
            return t('coupon.title1');
        }
        else if (iddiaStatus === 2) {
            return t('coupon.title2');
        }
        else if (iddiaStatus === 3) {
            return t('coupon.title3');
        }
        else {
            return t('coupon.title4');
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "my-profile-info-block" }, { children: [!isKioskUser && (isMobileView
                    ? _jsx("div", __assign({ className: "hdr-navigation-scrollable-bc" }, { children: _jsxs("div", __assign({ className: "hdr-navigation-scrollable-content", "data-scroll-lock-scrollable": "" }, { children: [_jsx(Link, __assign({ className: "hdr-navigation-link-bc ".concat(iddiaStatus == undefined ? 'active' : ''), to: base + '/hesabim/bets' }, { children: _jsxs("span", __assign({ className: "nav-menu-title" }, { children: [t('general.all'), _jsx("i", { className: "  count-blink-even ", "data-badge": "" }, void 0)] }), void 0) }), void 0), _jsx(Link, __assign({ className: "hdr-navigation-link-bc ".concat(iddiaStatus == 1 ? 'active' : ''), to: base + '/hesabim/bets/devam-edenler' }, { children: _jsxs("span", __assign({ className: "nav-menu-title" }, { children: [t('accountMenu.menu3.item2'), _jsx("i", { className: "  count-blink-even ", "data-badge": "" }, void 0)] }), void 0) }), void 0), _jsx(Link, __assign({ className: "hdr-navigation-link-bc ".concat(iddiaStatus == 2 ? 'active' : ''), to: base + '/hesabim/bets/kazanan' }, { children: _jsxs("span", __assign({ className: "nav-menu-title" }, { children: [t('coupon.title2'), _jsx("i", { className: "  count-blink-even ", "data-badge": "" }, void 0)] }), void 0) }), void 0), _jsx(Link, __assign({ className: "hdr-navigation-link-bc ".concat(iddiaStatus == 3 ? 'active' : ''), to: base + '/hesabim/bets/kaybeden' }, { children: _jsxs("span", __assign({ className: "nav-menu-title" }, { children: [t('coupon.title3'), _jsx("i", { className: "  count-blink-even ", "data-badge": "" }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0)
                    : _jsx("div", __assign({ className: "overlay-header" }, { children: getHeader() }), void 0)), _jsx("div", __assign({ className: "u-i-e-p-p-content-bc u-i-common-content", "data-scroll-lock-scrollable": "" }, { children: _jsx(ListCoupons, { params: params }, void 0) }), void 0)] }), void 0) }, void 0));
};
export default Sports;
var iddiaData = [];
var lockScroll = false;
var iddiaStatus = 1;
var timer = null;
var checkTimer;
var detailCouponId = null;
var couponNo = null;
export function ListCoupons(props) {
    var forceUpdate = useForceUpdate();
    var params = props.params;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var isKioskUser = member.is_kiosk;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    useEffect(function () {
        window.scrollTo(0, 0);
        iddiaData = [];
        fetchData(true);
    }, [params.couponId]);
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function () {
            if ((BetSlipOption.bettingInfoStatus === 1) ||
                (BetSlipOption.bettingInfoStatus === 2) ||
                (BetSlipOption.bettingInfoStatus === 3)) {
                window.scrollTo(0, 0);
                fetchData(true, 0, 0);
            }
        });
        return function () {
            betSlipActionSubject_subscription.unsubscribe();
        };
    }, []);
    useEffect(function () {
        window.addEventListener('scroll', triggerScroll);
        return function () {
            clearTimeout(timer);
            window.removeEventListener('scroll', triggerScroll);
        };
    }, []);
    var location = useLocation();
    useEffect(function () {
        couponNo = null;
        forceUpdate();
    }, [location]);
    iddiaStatus = paramStates[params.couponId];
    var fetchData = function (isFirst, forcePage, top) {
        if (isFirst === void 0) { isFirst = false; }
        if (forcePage === void 0) { forcePage = null; }
        if (top === void 0) { top = null; }
        try {
            // // @ts-ignore
            // document.getElementById('loadingAnimation').style.display = 'block';
            hasMore = false;
            if (isFirst) {
                iddiaData = [];
                page = forcePage !== null ? forcePage : 0;
                hasMore = true;
                setIsLoading(true);
            }
            var data = {
                token: Storage.get('token'),
                status: iddiaStatus < 2 ? '0,1' : (iddiaStatus == undefined ? '0,1,2,3' : iddiaStatus.toString()),
                page: page,
            };
            // @ts-ignore
            var objectHeight_1 = document.getElementById('InfiniteScroll').offsetHeight;
            // @ts-ignore
            var objectTop_1 = document.getElementById('InfiniteScroll').offsetTop;
            Api.start('post', env.list_api + '/order/api/orders/iddaa/', data, true, 10000)
                .then(function (result) {
                // // @ts-ignore
                // document.getElementById('loadingAnimation').style.display = 'none';
                if (result.status) {
                    if (result.data.length < 1) {
                        hasMore = false;
                        lockScroll = true;
                    }
                    else {
                        hasMore = true;
                    }
                    page += 1;
                    if (isFirst) {
                        iddiaData = result.data;
                    }
                    else {
                        iddiaData = iddiaData.concat(result.data);
                    }
                    forceUpdate();
                    if (!isFirst) {
                        if (top === 0) {
                            window.scrollTo(0, top);
                        }
                        else {
                            var threshold = window.outerHeight < 700 ? 600 : 700;
                            window.scrollTo(0, (objectHeight_1 - objectTop_1 - threshold));
                        }
                    }
                    timer = setTimeout(function () {
                        if (result.data.length >= 1) {
                            lockScroll = false;
                            if (iddiaData.length === 20 && objectHeight_1 < window.outerHeight) {
                                fetchData(false, 1, 0);
                            }
                        }
                        triggerScroll();
                    }, 500);
                }
                else {
                    modalServiceSubject.next({
                        title: t('coupon.unexpectedError'),
                        content: result.message,
                        confirm: {
                            cancel: { label: t('Ok') }
                        },
                        // timeout: 3000,
                    });
                }
            })
                .finally(function () {
                if (isFirst) {
                    setIsLoading(false);
                    forceUpdate();
                }
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    var triggerScroll = function () {
        var threshold = window.outerHeight < 968 ? 100 : 150;
        // @ts-ignore
        var objectHeight = document.getElementById('InfiniteScroll').offsetHeight;
        // @ts-ignore
        var objectTop = document.getElementById('InfiniteScroll').offsetTop;
        var visibleZone = (window.outerHeight - objectTop - threshold);
        if (objectHeight > visibleZone) {
            if ((objectHeight - visibleZone) < window.scrollY && !lockScroll) {
                lockScroll = true;
                fetchData(false);
            }
        }
    };
    var openCouponDetail = function (data) {
        if (data.status === 0) {
            modalServiceSubject.next({
                title: t('coupon.pendingTitle'),
                content: t('coupon.pendingContent', { count: data.pending_quantity }),
                confirm: {
                    cancel: {
                        label: t('Ok')
                    }
                }
            });
        }
        else {
            if (detailCouponId == data.id) {
                detailCouponId = null;
                forceUpdate();
            }
            else {
                detailCouponId = data.id;
                forceUpdate();
            }
        }
    };
    var apiService = new ApiService();
    var checkLiveCoupons = function (coupon_ids) {
        var updateData = {
            coupon_id_list: coupon_ids.join(','),
            token: Storage.get('token')
        };
        apiService.start('post', env.list_api + '/order/api/get_coupon_status/', updateData, true)
            .then(function (response) {
            if (response.status) {
                if (response.data.filter(function (el) { return el.status === 0; }).length > 0) {
                    response.data.forEach(function (c) {
                        if (Number(c.pending_quantity) === 0 && Number(c.status) === 1) {
                            var cop = iddiaData.find(function (el) { return el.id === c.id; });
                            if (cop) {
                                cop.status = c.status;
                                cop.approve_date = c.approve_date;
                                cop.approve_code = c.approve_code;
                                cop.coupon_quantity = c.coupon_quantity;
                                cop.pending_quantity = c.pending_quantity;
                            }
                            iddiaData[iddiaData.indexOf(cop)] = cop;
                        }
                        else if (Number(c.pending_quantity) > 0 && Number(c.status) === 0) {
                            var cop = iddiaData.find(function (el) { return el.id === c.id; });
                            if (cop) {
                                cop.status = c.status;
                                cop.approve_date = c.approve_date;
                                cop.approve_code = c.approve_code;
                                cop.coupon_quantity = c.coupon_quantity;
                                cop.pending_quantity = c.pending_quantity;
                            }
                            iddiaData[iddiaData.indexOf(cop)] = cop;
                        }
                        else if (Number(c.pending_quantity) === 0 && Number(c.status) !== 0) {
                            var cop = iddiaData.find(function (el) { return el.id === c.id; });
                            iddiaData.splice(iddiaData.indexOf(cop), 1);
                        }
                    });
                }
            }
            clearTimeout(checkTimer);
            forceUpdate();
        });
    };
    var pendingCounpons = iddiaData.filter(function (el) { return el.status === 0; });
    if (pendingCounpons.length > 0) {
        checkTimer = setTimeout(function () {
            var coupon_ids = pendingCounpons.map(function (el) { return el.id; });
            checkLiveCoupons(coupon_ids);
        }, 3000);
    }
    else {
        clearTimeout(checkTimer);
    }
    var getStatusText = function (status) {
        switch (status) {
            case 0:
                return t('coupon.status0');
            case 1:
                return t('coupon.status0');
            case 2:
                return t('coupon.status2');
            case 3:
                return t('coupon.status3');
            case 12:
                return t('coupon.status2');
            default:
                return status.toString();
        }
    };
    var handleSearch = function (e) {
        setIsLoading(true);
        couponNo = e;
        forceUpdate();
        var data = {
            token: Storage.get('token'),
            status: '0,1,2,3,12',
            page: 0,
            approve_code: couponNo,
        };
        Api.start('post', env.list_api + '/order/api/orders/iddaa/', data, true, 10000)
            .then(function (result) {
            if (result.status) {
                iddiaData = result.data;
            }
            else {
                modalServiceSubject.next({
                    title: t('error'),
                    content: result.message,
                    confirm: {
                        cancel: { label: t('Ok') }
                    },
                });
            }
        })
            .finally(function () {
            setIsLoading(false);
            forceUpdate();
        });
    };
    if (isKioskUser && !couponNo) {
        return (_jsx(KioskCheckCoupon, { onSearch: handleSearch }, void 0));
    }
    if (isMobileView) {
        return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "profits-items-container profits-items-sport", id: "InfiniteScroll" }, { children: [isLoading && (_jsx("div", __assign({ style: { marginTop: "100px" } }, { children: _jsx("div", { id: "loader" }, void 0) }), void 0)), !isLoading && iddiaData.length === 0 && (_jsx("div", __assign({ className: "bet-history-t-holder-hk-bc" }, { children: t('coupon.noCoupon') }), void 0)), !isLoading && iddiaData.map(function (data, key) {
                        return (_jsxs("div", __assign({ className: "bet-history-t-holder-hk-bc", onClick: function () { return openCouponDetail(data); } }, { children: [_jsxs("div", __assign({ className: "bet-history-t-b-row-hk-bc" }, { children: [_jsxs("div", __assign({ className: "bet-history-t-b-r-cell-hk-bc" }, { children: [_jsx("i", { className: "bet-history-express-icon bc-i-multiple-bet" }, void 0), _jsxs("div", __assign({ className: "bet-history-info-block" }, { children: [_jsxs("h3", __assign({ className: "bet-history-info-title-block" }, { children: [_jsx("span", __assign({ className: "ellipsis" }, { children: data.system && data.system !== '' ? t('general.system') + data.system : t('general.combine') }), void 0), _jsx("div", { className: "bet-history-bonus-bet-icons" }, void 0)] }), void 0), _jsxs("p", __assign({ className: "bet-history-id" }, { children: [_jsxs("span", { children: ["ID: ", data.approve_code] }, void 0), _jsx("i", { className: "bc-i-copy", style: { margin: '0 8px' } }, void 0), data.status === 1 &&
                                                                    _jsx(CashoutDetail, { data: data, isDetail: false, onSuccess: function () {
                                                                            iddiaData.splice(iddiaData.indexOf(data), 1);
                                                                            forceUpdate();
                                                                        } }, void 0), couponNo && data.status === 12 &&
                                                                    _jsx(KioskPayout, { data: data, isDetail: false, onSuccess: function () {
                                                                            iddiaData.splice(iddiaData.indexOf(data), 1);
                                                                            forceUpdate();
                                                                        } }, void 0)] }), void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ className: "bet-history-t-b-r-cell-hk-bc" }, { children: _jsxs("div", __assign({ className: "bet-history-info" }, { children: [_jsx("p", __assign({ className: "bet-history-status" }, { children: _jsx("span", __assign({ className: "ellipsis", "data-status": data.status }, { children: getStatusText(data.status) }), void 0) }), void 0), _jsx("time", __assign({ className: "bet-history-day" }, { children: data.approve_date ? dateTimeFormat(data.approve_date) : dateTimeFormat(data.create_date) }), void 0)] }), void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "competition-wrapper-bc", "data-scroll-lock-scrollable": "" }, { children: detailCouponId == data.id && _jsx(SportsDetail, { data: data }, void 0) }), void 0), _jsxs("div", __assign({ className: "bet-history-t-b-col-hk-bc" }, { children: [_jsxs("div", __assign({ className: "bet-history-stake-odds" }, { children: [_jsx("span", __assign({ className: "bet-history-title" }, { children: t('coupon.header3') }), void 0), _jsxs("b", __assign({ className: "bet-history-stake-money" }, { children: [currencyFormat(Number(data.amount) / (data.unit === 0 || data.unit === 2 ? 1 : 100) * Number(data.coupon_quantity)), " \u20BA"] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "bet-history-stake-odds" }, { children: [_jsx("div", __assign({ className: "bet-history-title" }, { children: _jsx("span", { children: t('betslip.oran') }, void 0) }), void 0), _jsx("b", __assign({ className: "bet-history-odds-coeff" }, { children: Number(data.total_ratio).toFixed(2) }), void 0)] }), void 0), _jsxs("div", __assign({ className: "bet-history-stake-odds" }, { children: [_jsx("div", __assign({ className: "bet-history-title" }, { children: _jsx("span", { children: t('betslip.winAmount') }, void 0) }), void 0), _jsxs("b", __assign({ className: "bet-history-odds-coeff" }, { children: [(data.status === 2 || data.status === 12) ? _jsx(_Fragment, { children: currencyFormat(Number(data.winning)) }, void 0) : _jsx(_Fragment, { children: currencyFormat(Number(data.profit) * Number(data.coupon_quantity)) }, void 0), " ", _jsx("span", {}, void 0)] }), void 0)] }), void 0)] }), void 0)] }), "coupon-" + key));
                    })] }), void 0) }, void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "betHistoryList-table" }, { children: _jsx("div", __assign({ className: "betHistoryList-thead" }, { children: _jsxs("div", __assign({ className: "betHistoryListEl" }, { children: [_jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: t('coupon.header1') }), void 0) }), void 0), _jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: t('coupon.header2') }), void 0) }), void 0), _jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: t('coupon.header3') }), void 0) }), void 0), _jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: t('coupon.header4') }), void 0) }), void 0), _jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: t('coupon.header5') }), void 0) }), void 0), _jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", __assign({ className: "ellipsis" }, { children: t('coupon.header6') }), void 0) }), void 0), _jsx("div", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("p", { className: "ellipsis" }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0), _jsx("div", __assign({ "data-test-id": "virtuoso-scroller", id: "InfiniteScroll", "data-virtuoso-scroller": "true", tabIndex: 0, style: { height: "100%", outline: "none", overflowY: "auto", position: "relative" } }, { children: _jsx("div", __assign({ "data-viewport-type": "element", style: { width: "100%", height: "100%", position: "absolute", top: "0px" } }, { children: _jsxs("div", __assign({ "data-test-id": "virtuoso-item-list", style: {
                            boxSizing: "border-box",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            marginTop: "0px"
                        } }, { children: [isLoading && (_jsx("div", __assign({ style: { marginTop: "100px" } }, { children: _jsx("div", { id: "loader" }, void 0) }), void 0)), !isLoading && iddiaData.length === 0 && (_jsx("div", __assign({ className: "betHistoryList-table" }, { children: _jsx("div", __assign({ className: "betHistoryList-tbody" }, { children: _jsx("ul", __assign({ className: "betHistoryListEl" }, { children: _jsx("li", __assign({ className: "betHistoryListEl-list-item", style: { width: "100%" } }, { children: t('coupon.noCoupon') }), void 0) }), void 0) }), void 0) }), void 0)), !isLoading && iddiaData.map(function (data, key) {
                                return _jsx("div", __assign({ "data-index": key, "data-known-size": "251", "data-item-index": key, style: { overflowAnchor: "none" } }, { children: _jsxs("div", __assign({ className: "betHistoryList-table" }, { children: [_jsx("div", __assign({ className: "betHistoryList-tbody" }, { children: _jsxs("ul", __assign({ className: "betHistoryListEl" }, { children: [_jsx("li", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsxs("div", __assign({ className: "betHistoryListElId" }, { children: [_jsx("i", { className: "bc-i-unsettled", "data-status": data.status }, void 0), _jsxs("div", __assign({ className: "betHistoryListEl-info" }, { children: [_jsx("p", __assign({ className: "betHistory-day" }, { children: _jsx("time", __assign({ className: "" }, { children: data.approve_date ? dateTimeFormat(data.approve_date) : dateTimeFormat(data.create_date) }), void 0) }), void 0), _jsxs("p", __assign({ className: "betHistory-Id" }, { children: [_jsx("span", { children: "ID:" }, void 0), _jsx("span", __assign({ className: "fw-normal", style: {
                                                                                            whiteSpace: 'nowrap',
                                                                                            overflow: 'hidden',
                                                                                            textOverflow: 'ellipsis',
                                                                                            maxWidth: '100px',
                                                                                        } }, { children: data.approve_code }), void 0), _jsx("i", { className: "bc-i-copy" }, void 0)] }), void 0), _jsx("p", __assign({ className: "bethistoryListEl-item-status" }, { children: _jsx("span", __assign({ className: "ellipsis", "data-status": data.status }, { children: getStatusText(data.status) }), void 0) }), void 0)] }), void 0)] }), void 0) }), void 0), _jsx("li", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsxs("div", __assign({ className: "betHistoryListEl-types" }, { children: [_jsx("i", { className: "bet-history-express-icon bc-i-multiple-bet" }, void 0), _jsxs("div", __assign({ className: "bet-history-info-block" }, { children: [_jsx("h3", __assign({ className: "bet-history-info-title-block ellipsis" }, { children: _jsx("span", __assign({ className: "ellipsis" }, { children: data.system && data.system !== '' ? t('general.system') + data.system : t('general.combine') }), void 0) }), void 0), _jsx("div", { className: "bet-history-bonus-bet-icons" }, void 0)] }), void 0)] }), void 0) }), void 0), _jsx("li", __assign({ className: "betHistoryListEl-list-item " }, { children: _jsx("div", __assign({ className: "bet-history-stake-odds" }, { children: _jsxs("b", __assign({ className: "bet-history-stake-money" }, { children: [currencyFormat(Number(data.amount) / (data.unit === 0 || data.unit === 2 ? 1 : 100) * Number(data.coupon_quantity)), " \u20BA"] }), void 0) }), void 0) }), void 0), _jsxs("li", __assign({ className: "betHistoryListEl-list-item" }, { children: [_jsx("div", __assign({ className: "bet-history-odds-title  ellipsis" }, { children: _jsx("span", { children: t('betslip.oran') }, void 0) }), void 0), _jsx("b", __assign({ className: "bet-history-odds-coeff" }, { children: Number(data.total_ratio).toFixed(2) }), void 0)] }), void 0), _jsx("li", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("div", __assign({ className: "bet-history-cashout-block" }, { children: _jsxs("div", __assign({ className: "bet-history-possible-win-block" }, { children: [_jsx("span", __assign({ className: "bet-history-title" }, { children: t('betslip.winAmount') }), void 0), _jsxs("span", __assign({ className: "bet-history-possible-win" }, { children: [(data.status === 2 || data.status === 12) ? _jsx(_Fragment, { children: currencyFormat(Number(data.winning)) }, void 0) : _jsx(_Fragment, { children: currencyFormat(Number(data.profit) * Number(data.coupon_quantity)) }, void 0), " ", _jsx("span", {}, void 0)] }), void 0)] }), void 0) }), void 0) }), void 0), _jsx("li", __assign({ className: "betHistoryListEl-list-item" }, { children: _jsx("div", __assign({ className: "betHistoryListEl-types" }, { children: _jsxs("div", __assign({ className: "betHistoryListEl-list-item-actions" }, { children: [data.status === 1 &&
                                                                            _jsx(CashoutDetail, { data: data, isDetail: false, onSuccess: function () {
                                                                                    iddiaData.splice(iddiaData.indexOf(data), 1);
                                                                                    forceUpdate();
                                                                                } }, void 0), couponNo && data.status === 12 &&
                                                                            _jsx(KioskPayout, { data: data, isDetail: false, onSuccess: function () {
                                                                                    iddiaData.splice(iddiaData.indexOf(data), 1);
                                                                                    forceUpdate();
                                                                                } }, void 0)] }), void 0) }), void 0) }), void 0), _jsx("li", __assign({ className: "betHistoryListEl-list-item", onClick: function () { return openCouponDetail(data); } }, { children: detailCouponId == data.id ?
                                                                _jsx("i", { className: "competition-icon-arrow-bc bc-i-small-arrow-up" }, void 0) :
                                                                _jsx("i", { className: "competition-icon-arrow-bc bc-i-small-arrow-down" }, void 0) }), void 0)] }), void 0) }), void 0), detailCouponId == data.id && _jsx(SportsDetail, { data: data }, void 0)] }), void 0) }), "coupon-" + key);
                            })] }), void 0) }), void 0) }), void 0)] }, void 0));
}
